(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["meccha-lang-switcher"] && !Shopify.designMode) return;
  try {
    (function () {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-mc-lang-toggle]');
      var open = document.querySelector('[data-mc-lang] .mc-lang__menu:not([hidden])');
      if (toggle) {
        e.preventDefault();
        var wrap = toggle.closest('[data-mc-lang]');
        var menu = wrap.querySelector('.mc-lang__menu');
        var isOpen = !menu.hasAttribute('hidden');
        if (isOpen) { menu.setAttribute('hidden', ''); toggle.setAttribute('aria-expanded', 'false'); }
        else { menu.removeAttribute('hidden'); toggle.setAttribute('aria-expanded', 'true'); }
        return;
      }
      // click outside → close any open menu
      if (open && !e.target.closest('.mc-lang__menu')) {
        open.setAttribute('hidden', '');
        var t = open.parentElement.querySelector('[data-mc-lang-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = document.querySelector('[data-mc-lang] .mc-lang__menu:not([hidden])');
      if (open) { open.setAttribute('hidden', ''); var t = open.parentElement.querySelector('[data-mc-lang-toggle]'); if (t) t.setAttribute('aria-expanded', 'false'); }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["meccha-quick-add"] && !Shopify.designMode) return;
  try {
    (function () {
    var I18N = window.MECCHA_I18N || {};
    var modal = document.getElementById('mc-qa');
    var content = modal ? modal.querySelector('.mc-qa__content') : null;
    var toastEl = document.getElementById('mc-toast');
    var toastTimer;
    var currentProduct = null;
    var selected = {};

    function money(cents) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }

    function toast(msg) {
      if (!toastEl) return;
      toastEl.textContent = msg;
      toastEl.hidden = false;
      requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toastEl.classList.remove('is-visible');
        setTimeout(function () { toastEl.hidden = true; }, 260);
      }, 2200);
    }

    function openCart() {
      var d = document.getElementById('cart-drawer');
      if (d && typeof d.open === 'function') {
        try { d.open(); return true; } catch (e) {}
      }
      var t = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (t) { t.click(); return true; }
      return false;
    }

    function refreshCart() {
      return fetch(window.location.pathname + '?sections=cart-drawer-section')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data['cart-drawer-section'];
          var wrap = document.getElementById('shopify-section-cart-drawer-section');
          if (html && wrap) { wrap.innerHTML = html; }
        })
        .catch(function () {});
    }

    function addToCart(variantId, qty) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty || 1 })
      }).then(function (r) {
        if (!r.ok) { return r.json().then(function (e) { throw e; }); }
        return r.json();
      });
    }

    function updateBubble(count) {
      var el = document.querySelector('.cart-bubble__text-count');
      if (el) el.textContent = count > 0 ? count : '';
      var icon = document.querySelector('.header-actions__cart-icon');
      if (icon) icon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
    }

    function finishAdd() {
      return Promise.all([
        fetch('/cart.js').then(function (r) { return r.json(); }).catch(function () { return null; }),
        refreshCart()
      ]).then(function (res) {
        if (res[0]) updateBubble(res[0].item_count);
        if (!openCart()) toast(I18N.added_to_cart || 'Added to bag');
      });
    }

    function quickAddDirect(btn) {
      btn.classList.add('is-loading');
      addToCart(btn.getAttribute('data-variant'), 1)
        .then(finishAdd)
        .then(function () { btn.classList.remove('is-loading'); })
        .catch(function (err) { btn.classList.remove('is-loading'); toast((err && err.description) || I18N.could_not_add || 'Could not add to bag'); });
    }

    function openModal() { modal.hidden = false; document.body.style.overflow = 'hidden'; }
    function closeModal() { modal.hidden = true; document.body.style.overflow = ''; }

    function findVariant() {
      if (!currentProduct) return null;
      for (var i = 0; i < currentProduct.variants.length; i++) {
        var v = currentProduct.variants[i];
        var ok = true;
        for (var j = 0; j < currentProduct.options.length; j++) {
          if (v.options[j] !== selected[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function updateState() {
      var v = findVariant();
      var priceEl = document.getElementById('mc-qa-price');
      var addBtn = document.getElementById('mc-qa-add');
      if (v) {
        if (priceEl) priceEl.textContent = money(v.price);
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? (I18N.add_to_bag || 'Add to bag') + ' · ' + money(v.price) : (I18N.sold_out || 'Sold out');
          addBtn.setAttribute('data-variant', v.id);
        }
      } else if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = I18N.unavailable || 'Unavailable';
      }
    }

    function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

    function renderModal() {
      var p = currentProduct;
      var media = p.featured_image
        ? '<img src="' + p.featured_image + '" alt="' + esc(p.title) + '">'
        : '';
      var html = '<div class="mc-qa__media" style="--c:' + (p._color || '#12b5e5') + '">' + media + '</div>';
      html += '<div class="mc-qa__info">';
      html += '<h3 id="mc-qa-title" class="mc-qa__title">' + esc(p.title) + '</h3>';
      html += '<div class="mc-qa__price" id="mc-qa-price">' + money(p.price) + '</div>';
      p.options.forEach(function (opt, i) {
        html += '<div class="mc-qa__opt"><div class="mc-qa__optname">' + esc(opt.name) + '</div><div class="mc-qa__values">';
        opt.values.forEach(function (val) {
          var active = selected[i] === val ? ' is-active' : '';
          html += '<button type="button" class="mc-qa__val' + active + '" data-opt="' + i + '" data-val="' + esc(val) + '">' + esc(val) + '</button>';
        });
        html += '</div></div>';
      });
      html += '<button type="button" class="mc-btn mc-qa__add" id="mc-qa-add">' + (I18N.add_to_bag || 'Add to bag') + '</button>';
      html += '</div>';
      content.innerHTML = html;
      updateState();
    }

    function openOptions(handle, color) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          currentProduct = p;
          currentProduct._color = color;
          selected = {};
          var dv = null;
          for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { dv = p.variants[i]; break; } }
          if (!dv) dv = p.variants[0];
          p.options.forEach(function (o, i) { selected[i] = dv.options[i]; });
          renderModal();
          openModal();
        })
        .catch(function () { toast(I18N.could_not_load || 'Could not load options'); });
    }

    document.addEventListener('click', function (e) {
      var add = e.target.closest('[data-mc-quickadd]');
      if (add) {
        e.preventDefault();
        e.stopPropagation();
        if (add.getAttribute('data-options') === 'true') {
          var card = add.closest('.mc-pc');
          var color = card ? getComputedStyle(card).getPropertyValue('--c').trim() : '';
          openOptions(add.getAttribute('data-handle'), color);
        } else {
          quickAddDirect(add);
        }
        return;
      }
      if (e.target.closest('[data-mc-qa-close]')) { closeModal(); return; }
      var val = e.target.closest('.mc-qa__val');
      if (val && content) {
        var oi = val.getAttribute('data-opt');
        selected[oi] = val.getAttribute('data-val');
        content.querySelectorAll('.mc-qa__val[data-opt="' + oi + '"]').forEach(function (b) { b.classList.remove('is-active'); });
        val.classList.add('is-active');
        updateState();
        return;
      }
      var qaAdd = e.target.closest('#mc-qa-add');
      if (qaAdd && !qaAdd.disabled) {
        qaAdd.disabled = true;
        addToCart(qaAdd.getAttribute('data-variant'), 1)
          .then(function () { closeModal(); return finishAdd(); })
          .catch(function (err) { qaAdd.disabled = false; toast((err && err.description) || I18N.could_not_add || 'Could not add to bag'); });
      }
    });

    document.addEventListener('click', function (e) {
      var atc = e.target.closest('.mc-pdp__atc, .mc-stickybar__atc');
      if (!atc) return;
      var form = document.getElementById('mc-pdp-form');
      if (!form) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var idInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      var id = idInput && idInput.value;
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      if (!id) return;
      atc.classList.add('is-loading');
      addToCart(id, qty)
        .then(finishAdd)
        .then(function () { atc.classList.remove('is-loading'); })
        .catch(function (err) { atc.classList.remove('is-loading'); toast((err && err.description) || I18N.could_not_add || 'Could not add to bag'); });
    }, true);

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) closeModal(); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["meccha-social-proof"] && !Shopify.designMode) return;
  try {
    (function () {
    function hash32(n){let x=(n^0x9E3779B9)>>>0;x=Math.imul(x^x>>>16,0x45d9f3b)>>>0;x=Math.imul(x^x>>>16,0x45d9f3b)>>>0;return ((x^x>>>16)>>>0)/4294967296;}
    function mulberry32(a){return function(){a=a+0x6D2B79F5|0;let t=Math.imul(a^a>>>15,1|a);t=t+Math.imul(t^t>>>7,61|t)^t;return ((t^t>>>14)>>>0)/4294967296;};}
    function smoothstep(a,b,t){t=t*t*(3-2*t);return a+(b-a)*t;}
    function timeNoise(nowMs,seed,nodeSec){var node=nowMs/1000/nodeSec,i=Math.floor(node),f=node-i;var r0=hash32((Math.imul(i,2654435761)^seed)>>>0);var r1=hash32((Math.imul(i+1,2654435761)^seed)>>>0);return smoothstep(r0,r1,f)*2-1;}
    var HOUR_W=[.15,.10,.08,.06,.06,.08,.15,.30,.50,.65,.75,.85,.95,.90,.85,.88,.92,.95,1.00,.98,.90,.70,.45,.25];
    var DAY_W=[.95,1.00,1.00,1.02,1.10,.85,.80];
    function baseline(now){var h=now.getHours(),m=now.getMinutes(),d=now.getDay();var hw=smoothstep(HOUR_W[h],HOUR_W[(h+1)%24],m/60);return hw*DAY_W[d];}
    function daySeed(now){return Math.floor(now.getTime()/86400000);}
    function pdpActive(now,pid,scale){
      var seed=(daySeed(now)^Math.imul(pid,40503))>>>0;
      var v=scale*baseline(now)*(1+0.22*timeNoise(now.getTime(),seed,240));
      v+=timeNoise(now.getTime(),seed^0xABCD,45)*0.6;
      return Math.max(3,Math.min(Math.round(scale*1.5),Math.round(v)));
    }

    function initViewers(){
      document.querySelectorAll('[data-mc-active]').forEach(function(el){
        var pid=parseInt(el.getAttribute('data-product-id'),10)||0;
        var scale=parseInt(el.getAttribute('data-scale'),10)||16;
        var out=el.querySelector('[data-mc-active-count]')||el;
        var render=function(){ out.textContent=pdpActive(new Date(),pid,scale); el.removeAttribute('hidden'); };
        render();
        (function loop(){ setTimeout(function(){render();loop();}, 30000+Math.random()*60000); })();
      });
    }

    var NAMES=['Jana','Peter','Lucia','Martin','Eva','Tomáš','Zuzana','Marek','Katarína','Ondřej','Simona','Filip','Barbora','Adam','Nikola','Jakub','Petra','Michal','Veronika','David','Tereza','Lukáš','Karolína','Matej','Kristína','Patrik','Dominika','Roman','Anna','Jan',
      'Piotr','Katarzyna','Krzysztof','Magdalena','Tomasz','Agnieszka','Michał','Zofia','Marcin','Aleksandra',
      'Lukas','Julia','Maximilian','Sophie','Felix','Laura','Jonas','Hannah','Leon','Lena','Paul','Emilia',
      'László','Eszter','Gábor','Réka','Zoltán','Bence','Anna',
      'Luca','Giulia','Marco','Sofia','Alessandro','Chiara','Matteo','Francesca',
      'Louis','Camille','Hugo','Léa','Antoine','Manon',
      'Pablo','Marta','Javier','Sara','Diego','Elena',
      'Sem','Daan','Lotte','Lars','Emma',
      'Ivan','Marija','Andrei','Maria','Ioana','Nina'];
    var INIT='ABCDEFGHIJKLMNOPRSTUVWZ';
    var CITIES=[['Bratislava',22],['Praha',20],['Košice',10],['Brno',10],['Nitra',6],['Žilina',6],['Ostrava',6],['Plzeň',5],['Trnava',4],['Olomouc',4],['Banská Bystrica',3],['Liberec',3],['Prešov',3],['Hradec Králové',2],
      ['Wien',6],['Budapest',5],['Warszawa',5],['Kraków',4],['Wrocław',3],['Berlin',5],['München',4],['Hamburg',3],['Frankfurt',3],
      ['Bucharest',3],['Zagreb',3],['Ljubljana',2],['Milano',4],['Roma',4],['Napoli',2],['Paris',5],['Lyon',2],['Madrid',4],['Barcelona',3],['Amsterdam',4],['Rotterdam',2],['Brussels',2],['Zürich',2],['Lisboa',2],['Athens',2],['Dublin',2],['Copenhagen',2],['Stockholm',2],['Helsinki',2],['Sofia',2],['Vilnius',1],['Riga',1],['Tallinn',1]];
    function weightedPick(pairs,r){var tot=0,i;for(i=0;i<pairs.length;i++)tot+=pairs[i][1];var x=r*tot;for(i=0;i<pairs.length;i++){x-=pairs[i][1];if(x<0)return pairs[i][0];}return pairs[0][0];}

    initViewers();

    var products=(window.MECCHA_PRODUCTS||[]).filter(function(p){return p&&p.n;});
    var el=document.getElementById('mc-proof');
    if(!el || !products.length) return;
    if(sessionStorage.getItem('mc-proof-off')==='1'){ el.remove(); return; }

    // Purchase names change on EVERY load and keep flowing over time — seeded from the
    // wall clock (not the day), so the feed is independent of session and never repeats
    // the same opening sequence. (The "X viewing" counter above stays time-deterministic.)
    var t0=Date.now();
    var rnd=mulberry32(((t0>>>0)^Math.imul(t0/65536|0,0x9e3779b9))>>>0);
    var lastCity='',lastName='';
    function nextPerson(){
      var name,city,guard=0;
      do { name=NAMES[Math.floor(rnd()*NAMES.length)]+' '+INIT[Math.floor(rnd()*INIT.length)]+'.'; city=weightedPick(CITIES,rnd()); guard++; } while((name===lastName||city===lastCity)&&guard<5);
      lastName=name; lastCity=city;
      return { name:name, city:city, p:products[Math.floor(rnd()*products.length)], minsAgo:2+Math.floor(rnd()*40) };
    }

    var elThumb=el.querySelector('[data-mc-proof-thumb]');
    var elTitle=el.querySelector('[data-mc-proof-title]');
    var elSub=el.querySelector('[data-mc-proof-sub]');
    var elMeta=el.querySelector('[data-mc-proof-meta]');
    el.querySelector('[data-mc-proof-close]').addEventListener('click',function(){ hide(); el.remove(); sessionStorage.setItem('mc-proof-off','1'); });

    var shown=0, MAX=8, timer=null;
    var I18N=window.MECCHA_I18N||{};
    function nextDelay(){ var t=Math.max(0.2, baseline(new Date())); var base=45000/t; var jit=0.7+hash32((Date.now()/1000|0))*0.8; return Math.min(300000, base*jit); }
    function schedule(ms){ clearTimeout(timer); timer=setTimeout(show, ms); }
    function hide(){ el.classList.remove('is-in'); setTimeout(function(){ if(!el.classList.contains('is-in')) el.setAttribute('hidden',''); }, 350); }
    function show(){
      if(document.hidden){ schedule(4000); return; }
      var e=nextPerson();
      elThumb.style.backgroundImage = e.p.img ? 'url('+e.p.img+')' : 'none';
      elTitle.textContent = e.name+' · '+e.city;
      elSub.textContent = (I18N.proof_bought||'Bought')+' '+e.p.n;
      elMeta.textContent = e.minsAgo+' '+(I18N.proof_time||'min ago · verified');
      el.removeAttribute('hidden');
      requestAnimationFrame(function(){ el.classList.add('is-in'); });
      shown++;
      setTimeout(hide, 6000);
      if(shown<MAX) schedule(nextDelay());
    }

    document.addEventListener('visibilitychange',function(){ if(document.hidden) clearTimeout(timer); });
    schedule(9000 + Math.random()*6000);
  })();
  } catch(e) { console.error(e); }
})();

})();
